var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import debounce from 'lodash.debounce';
// TODO(React18): Might want to upgrade this dependency
// (see https://github.com/ZeeCoder/use-resize-observer/issues/90).
// The issue seems to be related to Strict Mode, not React 18 specifically.
import useResizeObserver from 'use-resize-observer/polyfilled';
/**
 * A hook for components that need to calculate their layout based on a container width.
 *
 * @private
 */
export function useDynamicLayoutCalculation(_a) {
    var _b = _a.debounce, debounceProp = _b === void 0 ? false : _b, _c = _a.debounceOptions, _d = _c === void 0 ? {} : _c, _e = _d.leading, leading = _e === void 0 ? false : _e, _f = _d.waitMs, waitMs = _f === void 0 ? 500 : _f, ref = _a.ref;
    // State
    var _g = __read(React.useState(false), 2), isLayoutCalculatable = _g[0], setIsLayoutCalculatable = _g[1];
    var _h = __read(React.useState({
        height: undefined,
        width: undefined,
    }), 2), observedSize = _h[0], setObservedSize = _h[1];
    var onResize = React.useMemo(function () {
        // TODO(React18): I think using `debounce()` like this causes a
        // "Can't call setState (or forceUpdate) on an unmounted component" React warning.
        // This type of warning will be removed in React 18, but it would be nice to fix the root issue anyway:
        // We should use a debounce hook (either a 3rd-party lib or build our own)
        // that cancels the callback timeout when the component is unmounted.
        if (debounceProp)
            return debounce(setObservedSize, waitMs, { leading: leading });
        return undefined;
    }, [debounceProp, leading, waitMs]);
    // Refs
    var _j = useResizeObserver({ onResize: onResize, ref: ref }), height = _j.height, width = _j.width;
    // In case the consumer is using SSR, don't trigger the layout effects until after hydration
    // (see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85#option-2-lazily-show-component-with-uselayouteffect).
    React.useEffect(function () {
        setIsLayoutCalculatable(true);
    }, []);
    return __assign({ isLayoutCalculatable: isLayoutCalculatable }, (debounceProp ? observedSize : { height: height, width: width }));
}
